// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"7e503fba","323":"d87c75ef","391":"bd81d95b","514":"4ce1e9b4","536":"13e25f4e","587":"b77e054e","623":"7d3b7e9d","674":"8f51585e","927":"fbb2b2b0","956":"86aa2b6c"}[chunkId] + ".chunk.js";
};